// Display rules for PEARLI monthly trends. Statuses come from the API; the browser never recomputes them.

export const BENCHMARK = 3.2;

export const STATUS = {
    good: { label: "Good", color: "#74E1B4", background: "#EDFCF5", ink: "#0C7A55" },
    warning: { label: "Warning", color: "#F2B544", background: "#FFFBEB", ink: "#92400E" },
    attention: { label: "Needs attention", color: "#FCA5A5", background: "#FEF2F2", ink: "#B91C1C" },
    none: { label: "No data", color: "#CBD5E1", background: "#F8FAFC", ink: "#64748B" },
};

export const TREND_WORD = {
    rising: "↗ Rising",
    falling: "↘ Falling",
    stable: "→ Stable",
    unknown: "One month only",
};

export const DOMAIN_NAMES = [
    "Physical",
    "Emotional",
    "Acceptance",
    "Relationships",
    "Loving Kindness",
    "Intellectual",
];

const monthDate = (key) => {
    const [year, month] = String(key).split("-").map(Number);
    return new Date(year, month - 1, 1);
};

export const shortMonth = (key) =>
    monthDate(key).toLocaleDateString("en-US", { month: "short" });

export const longMonth = (key) =>
    monthDate(key).toLocaleDateString("en-US", { month: "long", year: "numeric" });

// "Apr – Sep 2026", "Nov 2025 – Feb 2026" or "September 2026".
export const rangeText = (start, end) => {
    if (start === end) return longMonth(start);
    const sameYear = start.slice(0, 4) === end.slice(0, 4);
    return `${shortMonth(start)}${sameYear ? "" : ` ${start.slice(0, 4)}`} – ${shortMonth(end)} ${end.slice(0, 4)}`;
};

export const countText = (count, countLabel) => {
    if (countLabel === "records") {
        return `${count} assessment record${count === 1 ? "" : "s"}`;
    }
    return `${count} participant${count === 1 ? "" : "s"}`;
};
